export const normal14 = `
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export const normal14Italic = `
  font-weight: 400;
  font-style: italic;
  font-size: 14px;
  line-height: 16px;
`;

export const normal14Uppercase = `
  font-weight: 400;
  font-size: 14px;
  text-transform: uppercase;
  line-height: 16px;
`;

export const normal16Italic = `
  font-weight: 400;
  font-style: italic;
  font-size: 16px;
  line-height: 24px;
`;

export const normal16 = `
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;

export const normal16Uppercase = `
  font-weight: 400;
  font-size: 16px;
  text-transform: uppercase;
  line-height: 24px;
`;

export const normal20 = `
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
`;

export const normal22 = `
  font-weight: 400;
  font-size: 22px;
  line-height: 24px;
`;

export const semibold14 = `
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;

export const semibold16 = `
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;

export const semibold40 = `
  font-weight: 500;
  font-size: 40px;
`;

/**
 * @deprecated use TypographyComponents instead, or typographyMixins if needed
 */
export const fontMixins = {
  normal14,
  normal14Italic,
  normal14Uppercase,
  normal16Italic,
  normal16,
  normal16Uppercase,
  normal20,
  normal22,
  semibold14,
  semibold16,
  semibold40,
};

export type FontMixins = keyof typeof fontMixins;
